import TemplateRow from "./TemplateRow";
import emptyImg from "../../../../assets/img/empty-state.png";

export default function TemplateTable({
  data,
  page = 1,
  itemsPerPage = 10,
  total = 0,
}) {
  return (
    <div className="notice-template-table">
      <div className="notice-template-table-header">
        <div>No</div>
        <div>제목</div>
        <div>작성자</div>
        <div>작성일</div>
        <div>조회수</div>
      </div>

      {data.length === 0 ? (
        <>
          <div className="notice-template-empty">
            <img
              src={emptyImg}
              alt="empty"
              className="notice-template-empty-img"
            />
            <p>작성된 글이 없습니다.</p>
          </div>

          <div className="notice-template-empty-line" />
        </>
      ) : (
        data.map((item, index) => {
          const displayNo = String(
            total - ((page - 1) * itemsPerPage + index)
          ).padStart(3, "0");

          return (
            <TemplateRow
              key={item.id}
              item={item}
              displayNo={displayNo}
            />
          );
        })
      )}
    </div>
  );
}